import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UIButton } from "../../_app/components";
import StatusChip from "../../_app/components/StatusChip";
import { rowParser } from "../../_app/components/Table/helpers";
import UIDataTable, { UIDataTableState } from "../../_app/components/Table/UIDataTable";
import UILoader from "../../_app/components/UILoader";
import Main from "../../_app/layouts/Main";
import { createStylesheet } from "../../_app/utils/styles";
import { useMobileAssetsWithEligibility } from "../../asset/hooks";
import { Feature } from "../../feature/types";
import FiltersCard from "../../filter/components/FiltersCard";
import { useAllFilters, useFilterQueries } from "../../filter/hooks";
import BillLimitAlertsTabBar from "../components/BillLimitAlerts/BillLimitAlertsTabBar";

export const BillLimitAlertsCli = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [canView, setCanView] = useState(false);
  const rowCountOptions = [25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState(rowCountOptions[0]);
  const queries = useFilterQueries();
  const { data: clis, isFetching } = useMobileAssetsWithEligibility(page, rowCount, queries, undefined, { enabled: canView });

  const handleTableChange = (action: string, state: UIDataTableState) => {
    switch (action) {
      case "changePage":
        setPage(state.page);
        break;
      case "changeRowsPerPage":
        setRowCount(state.rowsPerPage);
        break;
    }
  };

  useEffect(
    function handleFilterChange() {
      setPage(0);
    },
    [queries],
  );

  return (
    <Main
      title="Bill Limit Alerts"
      data-cy="bill-limit-alerts-cli-page"
      needSelectedAccount
      feature={Feature.BillLimitAlerts}
      accessGrantedCb={() => setCanView(true)}
    >
      <BillLimitAlertsTabBar selectedTab="bill-limit-alerts-cli">
        <>
          <FiltersCard fetchHook={useAllFilters} hasReset={false} hasDownload={false} usage="BILL_LIMIT" />
          {isFetching ? (
            <div className={classes.loader}>
              <UILoader />
            </div>
          ) : (
            <>
              <div data-cy="bill-limit-alerts-cli-table">
                <UIDataTable
                  title={""}
                  columns={[
                    "CLI/Identifier",
                    "",
                    "Tag",
                    {
                      label: "",
                      name: "",
                      options: {
                        setCellProps: () => ({
                          style: { textAlign: "right" },
                        }),
                      },
                    },
                  ]}
                  data={
                    clis?.content?.map((item) => {
                      return rowParser([
                        item.cli,
                        !item.eligible ? <StatusChip status="FAILED" label="Not Eligible" /> : " ",
                        item.tag,
                        <UIButton
                          variant="text"
                          color="primary"
                          data-cy="edit"
                          disabled={!item.eligible}
                          onClick={() => {
                            navigate(`/bill-limit-alerts-cli/${item.id}`);
                          }}
                        >
                          Edit
                        </UIButton>,
                      ]);
                    }) || []
                  }
                  options={{
                    page,
                    rowsPerPage: rowCount,
                    rowsPerPageOptions: rowCountOptions,
                    count: clis?.totalElements ?? 0,
                    onTableChange: handleTableChange,
                    fixedHeader: true,
                    pagination: true,
                    download: false,
                    elevation: 1,
                    print: false,
                    selectToolbarPlacement: "none",
                    filter: false,
                    sort: false,
                    search: false,
                    serverSide: true,
                    selectableRows: "none",
                    rowHover: true,
                    setTableProps: () => ({ size: "small" }),
                    viewColumns: false,
                  }}
                />
              </div>
            </>
          )}
        </>
      </BillLimitAlertsTabBar>
    </Main>
  );
};

const useStyles = createStylesheet((theme) => ({
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "40vh",
  },
}));

export default BillLimitAlertsCli;
